import { render, staticRenderFns } from "./item-honor.vue?vue&type=template&id=603a48cd&scoped=true"
import script from "./item-honor.vue?vue&type=script&lang=js"
export * from "./item-honor.vue?vue&type=script&lang=js"
import style0 from "./item-honor.vue?vue&type=style&index=0&id=603a48cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a48cd",
  null
  
)

export default component.exports